import { Construction } from 'lucide-react'
import attireIllustration from '@/assets/planner/attire.svg'
import beautyIllustration from '@/assets/planner/beauty.svg'
import decorIllustration from '@/assets/planner/decor.svg'
import musicIllustration from '@/assets/planner/music.svg'
import receptionIllustration from '@/assets/planner/reception.svg'
import { EmptyState } from '@/patterns/empty-state'
import { Screen } from '@/patterns/screen'
import { NAV } from './app-layout'

const illustrations: Record<string, string | undefined> = {
  'jidlo-a-piti': receptionIllustration,
  'hudba-a-zabava': musicIllustration,
  'vizazista-a-stylistka': beautyIllustration,
  'vizual-a-dekorace': decorIllustration,
  'saty-oblek-a-prsteny': attireIllustration,
}

/** Sidebar items that don't have a prototype screen yet. */
export function ComingSoon({ slug }: { slug: string }) {
  const item = NAV.flatMap((section) =>
    section.items.map((entry) => ({ ...entry, heading: section.heading })),
  ).find((entry) => entry.to === `/soon/${slug}`)
  return (
    <Screen
      eyebrow={item?.heading ?? 'Prototyp'}
      title={item?.label ?? 'Připravujeme'}
      illustration={
        illustrations[slug] ? (
          <img src={illustrations[slug]} alt="" className="h-auto w-full" />
        ) : undefined
      }
    >
      <EmptyState
        icon={<Construction />}
        title="Připravujeme v prototypu"
        description="Tahle obrazovka v prototypu zatím není. Najdete ji v aplikaci a postupně ji sem doplníme."
      />
    </Screen>
  )
}
